import { useLocalStorage } from '@sixfold/app-utils';

type LastViewedContextType = 'company' | 'shared-view';

export const useLastViewedContext = () => useLocalStorage<LastViewedContextType>('last-viewed-context');

export const useLastViewedCompanyId = () => useLocalStorage<string>('last-viewed-company');

export const useLastViewedSharedViewId = () => useLocalStorage<string>('last-viewed-shared-view');
